import React, { useState } from 'react';
import { Header } from './components/Header';
import { ChatInterface } from './components/ChatInterface';
import { WorkflowAutomation } from './components/WorkflowAutomation';
import { Dashboard } from './components/Dashboard';
import { Footer } from './components/Footer';
import { CandidateSection } from './components/CandidateSection';
export function App() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [language, setLanguage] = useState('en');
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-0">
      <Header activeTab={activeTab} setActiveTab={setActiveTab} language={language} setLanguage={setLanguage} data-id="element-1" />
      <main className="flex-grow w-full" data-id="element-2">
        {activeTab === 'dashboard' && <Dashboard language={language} data-id="element-3" />}
        {activeTab === 'chat' && <ChatInterface language={language} data-id="element-4" />}
        {activeTab === 'workflow' && <WorkflowAutomation language={language} data-id="element-5" />}
        {activeTab === 'candidates' && <CandidateSection language={language} data-id="element-6" />}
      </main>
      <Footer language={language} data-id="element-7" />
    </div>;
}